/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const restaurantType = async (): Promise<any> => {
  const resType = useJSONStore.getState().resType;
  const token = useUserStore.getState().userToken;
  const setResType = useJSONStore.getState().setResType;

  if (resType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.resType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setResType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default restaurantType;
